import { Fragment, useEffect, useState } from 'react';

import { getData } from './getPokeData.js';

const emojiSpace = 240;

const TYPES_ARR = [
  'Grass',
  'Poison',
  'Fire',
  'Flying',
  'Water',
  'Bug',
  'Normal',
  'Electric',
  'Ground',
  'Fairy',
  'Fighting',
  'Psychic',
  'Rock',
  'Steel',
  'Ice',
  'Ghost',
  'Dragon',
  'Dark',
];

const GEN_ARR = [151, 251, 386, 493, 649, 721, 809, 898];

function parseSize(size) {
  if (size < 2) {
    return `${size * 10}mm`;
  }
  if (size < 100) {
    return `${size}cm`;
  }
  if (size < 100 * 1000) {
    return `${Math.round(size * 100) / 100 / 100}m`;
  }
  return `${Math.round(size / 100 / 10) / 100}km`;
}

function App() {
  const [rawData, rawDataSet] = useState([]);
  const [data, dataSet] = useState([]);
  const [scroll, scrollSet] = useState(0);
  const [filter, filterSet] = useState('ALL');
  const [currentGeneration, currentGenerationSet] = useState(0);

  useEffect(() => {
    getData().then((res) => {
      dataSet(res);
      window.res = res;
      rawDataSet(res);
    });

    function loop() {
      scrollSet(Math.round(window.pageYOffset));
      window.requestAnimationFrame(loop);
    }
    window.requestAnimationFrame(loop);
  }, []);

  useEffect(() => {
    document.body.style.height = `${
      emojiSpace * data.length + window.innerHeight - emojiSpace * 1.5
    }px`;
  }, [data]);

  useEffect(() => {
    dataSet(
      rawData.filter((pokemon) => {
        if (currentGeneration !== 'ALL') {
          const lowerBound = GEN_ARR[currentGeneration - 1]
            ? GEN_ARR[currentGeneration - 1]
            : 0;
          const upperBound = GEN_ARR[currentGeneration];

          if (upperBound < pokemon.number || lowerBound > pokemon.number)
            return false;
        }

        if (filter === 'ALL') return true;
        return pokemon.types.includes(filter);
      })
    );
  }, [filter, currentGeneration, rawData]);

  return (
    <Fragment>
      <div className="poke-controls">
        <div className="select-container">
          <select
            value={filter}
            onChange={(evt) => {
              filterSet(evt.target.value);
            }}
          >
            <option key={'ALL'} value={'ALL'}>
              {'All Types'}
            </option>
            {TYPES_ARR.map((type) => {
              return (
                <option key={type} value={type}>
                  {type}
                </option>
              );
            })}
          </select>
        </div>

        <div className="select-container">
          <select
            value={currentGeneration}
            onChange={(evt) => {
              currentGenerationSet(evt.target.value);
            }}
          >
            <option key={'ALL'} value={'ALL'}>
              {'All Gens'}
            </option>
            {GEN_ARR.map((type, num) => {
              return (
                <option key={num} value={num}>
                  Generation {num + 1}
                </option>
              );
            })}
          </select>
        </div>
      </div>

      <div className="emoji-display">
        {data.map((pokemon, idx) => {
          const windowWidth = window.innerWidth;
          const compoundDistance =
            windowWidth / 2 + idx * emojiSpace - emojiSpace;

          let relativeDistance = compoundDistance - scroll;

          // Slow the scrolling at the beginning of the screen
          if (relativeDistance < windowWidth / 2) {
            relativeDistance =
              relativeDistance * 0.1 +
              (0.9 * (relativeDistance + windowWidth * 0.5)) / 2;
          }

          // Don't render the emoji if out of window
          if (
            relativeDistance < -emojiSpace * 1 ||
            relativeDistance > windowWidth - emojiSpace * -1
          ) {
            return null;
          }

          let emojisToScale = [
            Math.floor(scroll / emojiSpace),
            Math.ceil(scroll / emojiSpace),
          ];

          emojisToScale = emojisToScale
            .map((idx) => {
              if (idx < 0) return 0;
              if (idx > data.length - 1) return data.length - 1;
              return idx;
            })
            .map((idx) => data[idx]);

          const floorCeilProgress = (scroll / emojiSpace) % 1;
          const floatScale =
            floorCeilProgress * emojisToScale[1].height +
            (1 - floorCeilProgress) * emojisToScale[0].height;

          const calculatedScaleR = Math.min(pokemon.height / floatScale, 8);

          const calculatedScale = Math.round(calculatedScaleR * 1000) / 1000;

          let opacity = 1;
          if (calculatedScale > 3) {
            const diff = (calculatedScale - 3) / 8;
            opacity = Math.max(1 - diff, 0);
          }

          return (
            <div
              className="emoji-container"
              style={{
                transform: `translatex(${relativeDistance}px)`,
              }}
              key={idx}
            >
              <div
                className="emoji"
                style={{
                  opacity,
                  transform: `scale(${calculatedScale})`,
                }}
              >
                <img
                  style={{ height: 140, width: 'auto' }}
                  src={`/pokemon-to-scale/pokemon/${pokemon.number}.png`}
                />
              </div>
              <div>{parseSize(pokemon.height)}</div>
              <div>
                #{pokemon.number} {pokemon.name}
              </div>
            </div>
          );
        })}
      </div>
    </Fragment>
  );
}

export default App;
